import Carousel from "react-multi-carousel";
import "./Bloglist.scss";
import "../../Components/StudentStories.scss";
import "react-multi-carousel/lib/styles.css";
import SiteReviews from "../../Components/site-reviews/SiteReviews";
import BlogBanner from "./components/Banner";
import BlogCard from "./components/BlogCard";
import WhatsAppCMP from "../../Components/WhatsApp";
import { useEffect, useState } from "react";
import { getCategoriesBlogsPagination } from "../../services/getBlogs";
import { toast } from "react-toastify";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
const BlogsList = () => {
  const [blogs, setBlogs] = useState([]);
  const fetchBlogs = async () => {
    try {
      const response = await getCategoriesBlogsPagination({
        page: 1,
        limit: 5,
      });
      setBlogs(response?.data);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 767, min: 320 },
      items: 1,
    },
  };

  const breadCrumbData = [{ label: "Home", path: "/" }, { label: "Blogs" }];

  return (
    <div>
      <div className="container">
        <div className="row mt-2 mb-2 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
      </div>
      <BlogBanner />
      <SiteReviews />
      <div className="container mt-5 mb-5">
        <div className="student-stories-container">
          <div className="blogs-list-container">
            {blogs &&
              blogs.length > 0 &&
              blogs.map((category, index) => (
                <div key={category._id} className="mb-5">
                  <h1 className="blogs-title">{category.title}</h1>

                  <Carousel
                    responsive={responsive}
                    autoPlay
                    arrows={false}
                    swipeable
                    draggable
                    showDots={true}
                    infinite
                    itemClass="carousel-item-padding"
                  >
                    {category.blogs && category.blogs.length > 0 ? (
                      category.blogs.map((blog, i) => (
                        <div className="carousel story" key={blog._id}>
                          <BlogCard data={blog} />
                        </div>
                      ))
                    ) : (
                      <p>No blogs found</p>
                    )}
                  </Carousel>
                </div>
              ))}
          </div>
          <WhatsAppCMP />
        </div>
      </div>
    </div>
  );
};

export default BlogsList;
